import { type Installation, installationSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  installations: z.array(installationSchema),
});

interface Params {
  projectId: string;
  installationId: string | number;
  noRetry?: boolean;
}

export function useInstallation({ projectId, installationId, noRetry = false }: Params) {
  const url = `/projects/${projectId}/installations`;

  const { data, error, isLoading, refetch, isFetching } = useQuery<{
    installations: Installation[];
  }>({
    queryKey: queryKeys.getInstallations(projectId),
    queryFn: () => get({ url, schema: responseSchema }),
    enabled: !!projectId && !!installationId,
    retry: !noRetry,
  });

  const installation = useMemo(
    () => data?.installations.find((installation) => installation.installationId == installationId),
    [data?.installations, installationId]
  );

  return {
    installation,
    error,
    isLoading,
    isFetching,
    refetch,
  };
}
